import AddoDjan from '../Pictures/Executives/Addo-Djan-min.jpg'
import Yeboah from '../Pictures/Executives/Yeboah.jpg'
import Odei from '../Pictures/Executives/Odei.jpg'
import Bampoe from '../Pictures/Executives/Bampoe.jpg'
import Dodzi from '../Pictures/Executives/Dodzi.jpg'
import Ashamatey from '../Pictures/Executives/Ashamatey.jpeg'



export const Executives = [
    
    {
        id:'1',
        position: 'President',
        name: 'Isaac Bediako Odei',
        portrait: Odei,
    },
    {
        id:'2',
        position: 'Vice President',
        name: 'Ing. Samuel Saforo Bampoe, MBA',
        portrait: Bampoe,
    },

    {
        id:'3',
        position: 'Secretary',
        name: 'Ing. Augustine Yeboah, MBA',
        portrait: Yeboah,
    },
    {
        id:'6',
        position: 'Assistant Secretary',
        name:'Felicia Natacha Ashamatey',
        portrait: Ashamatey,
    },
    {
        id:'4',
        position: 'Treasurer',
        name:'F. Thomas Addo-Djan, Dip. Mgmt.',
        portrait: AddoDjan,
    },
     {
        id:'5',
        position: 'Welfare Officer',
        name:'Ing. Carruthers Kofi Dodzi Kodzitse',
        portrait: Dodzi,
    },






]